import isNil from 'lodash/isNil';
import { useMemo } from 'react';

import { TransactionProps } from '../types';

export interface UseFormHeightArgs {
  transaction: TransactionProps;
  hasOptions: boolean;
  hasAction: boolean;
}

export default function useFormHeight({ transaction, hasOptions, hasAction }: UseFormHeightArgs): number {
  const fieldsHeightSubstract = useMemo(
    () =>
      [
        !transaction.isFPS ? 65 : 0,
        // eslint-disable-next-line no-nested-ternary
        !transaction.person?.phone && !transaction.person?.name
          ? 77
          : !transaction.person?.phone || !transaction.person?.name
          ? 24
          : 0,
        isNil(transaction.sbpId) ? 53 : 0,
        !transaction.message ? 53 : 0,
        !transaction.bank ? 53 : 0,
        !hasAction ? 60 : -20,
      ].reduce((result, val) => result + val, 0),
    [hasAction, transaction.bank, transaction.isFPS, transaction.message, transaction.person, transaction.sbpId],
  );
  return useMemo(() => (hasOptions ? 820 : 660) - fieldsHeightSubstract, [fieldsHeightSubstract, hasOptions]);
}
